import React, {Component} from "react";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {graphql} from "react-apollo";
import SubscriptionList from "../shared/SubscriptionList";
import AccessList from "../shared/AccessList";
import DeliveryList from "../shared/DeliveryList";
import OrderList from "../shared/OrderList";
import CartList from "../shared/CartList";
import AccountNotifications from "../shared/AccountNotifications";
import CreditCardList from "../shared/CreditCardList";
import ChargesList from "../shared/ChargesList";
import {GET_ACCOUNT} from "../../queries/customers";


class AccountPageView extends Component {

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    const optionalSection = this.props.data.account.deleted
      ? <Section title="This account was deleted"></Section>
      : null;

    return (
      <div className="AccountPageView">
        {optionalSection}

        <Section title="Subscriptions">
          <SubscriptionList accountId={this.props.accountId} />
        </Section>

        <Section title="Orders">
          <OrderList accountId={this.props.accountId} />
        </Section>

        <Section title="Deliveries">
          <DeliveryList accountId={this.props.accountId} /> 
        </Section>

        <Section title="Payment Methods">
          <CreditCardList accountId={this.props.accountId} /> 
        </Section>

        <Section title="Charges / Payments">
          <ChargesList accountId={this.props.accountId} /> 
        </Section>

        <Section title="Cart">
          <CartList accountId={this.props.accountId} />
        </Section>

        <Section title="Notifications">
          <AccountNotifications accountId={this.props.accountId} />
        </Section>

        <Section title="Access">
          <AccessList accountId={this.props.accountId} />
        </Section>
      </div>
    )    
  }

}

const Section = (props) => {
  return (
    <div className="section">
      <h4>{props.title}</h4>
      <div className="inner">
        {props.children}
      </div>
    </div>
  )
}


const withQuery = graphql(GET_ACCOUNT, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      accountId: props.accountId
    }    
  })
})

export default withQuery(AccountPageView);